import { Stack, Typography } from "@mui/material";
import PlansTable from "./components/PlansTable";
import { useMemo } from "react";
import { useGetFilesQuery } from "src/api/services/bucketApi";
import { useSearchParams } from "react-router-dom";
import { toNumber } from "src/utils/toNumber";
import { LIMIT, PAGE, STATUS } from "src/constants/searchParams";
import Filter from "./components/Filter";
import { filters } from "./utils/filters";
import UploadButtons from "../../components/UploadButtons/UploadButtons";

const FitnessAndNutrition = () => {
  const [params] = useSearchParams();

  const page = useMemo(() => toNumber(params.get(PAGE)), [params]);
  const limit = useMemo(() => toNumber(params.get(LIMIT)), [params]);

  const from = useMemo(() => {
    return page * limit;
  }, [limit, page]);

  const to = useMemo(() => {
    return from + limit - 1;
  }, [limit, from]);

  const queryParams = useMemo(
    () => ({
      status: params.get(STATUS) ?? undefined,
      from,
      to,
    }),
    [from, params, to],
  );

  const { data } = useGetFilesQuery(queryParams);

  const { plans, count } = useMemo(() => {
    if (data == null) return { plans: [], count: 0 };

    return {
      plans: data.data.map((plan) => plan),
      count: data.count,
    };
  }, [data]);

  return (
    <Stack gap="32px">
      <Typography variant="h4" fontWeight={600}>
        Fitness and Nutrition Plans
      </Typography>
      <Stack direction="row" gap={2}>
        <UploadButtons />
        {filters.map((filter) => (
          <Filter current={filter} key={filter.name} />
        ))}
      </Stack>
      <Stack gap={3} mt={3}>
        <PlansTable plans={plans} total={count} />
      </Stack>
    </Stack>
  );
};

export default FitnessAndNutrition;
